module.exports = __webpack_public_path__ + "ttnyc-logo.jpg?ed30eaa1c16255a506c034c894b8fc05";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/ttnyc-logo.jpg
// module id = 602
// module chunks = 0